<cs-header>
  <cs-header-title>{{ LL.redeemCode.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <div class="form-content">
    <cs-form-field [label]="LL.redeemCode.labels.enterCode()">
      <cs-input id="key-input" [(value)]="key" [placeholder]="LL.redeemCode.placeholders.codeFormat()"></cs-input>
    </cs-form-field>
    @if (message === '') {
      <cs-note>{{ LL.redeemCode.notes.codeWillBeRedeemed({email: email}) }}</cs-note>
    }
    @if (message !== '') {
      <cs-note class="error-message">{{ message }}</cs-note>
    }
  </div>
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="onCancelButtonClick($event)">
  <cs-button primary medium id="redeem-button" (click)="handleRedeem()" [label]="LL.redeemCode.buttons.redeem()"></cs-button>
</cs-page-action-buttons>
